export default {
  styleOverrides: {
    root: {
      margin: '16px 0'
    }
  }
};
